import { Classified } from '~/models/classified/types'

export interface NotificationTopic {
  name: string
  value: string
  enabled: boolean
}

export type TopicMap = Map<string, NotificationTopic>

export interface NotificationGroup {
  children: []
  name: string
  type: string
  value: string
}

export interface NotificationSettingsOption {
  enabledApp: boolean
  enabledEmail: boolean
  type: 'group' | 'option'
  value: string
  label: string
}
export interface NotificationSettingsOptions {
  type: string
  options?: NotificationSettingsOption[]
  label: string
}

export interface NotificationSettings {
  hasSubgroups: boolean
  type: 'group' | 'option'
  options: NotificationSettingsOptions[]
}
export interface NotificationSettingsTopic {
  enabled: boolean
  value: string
  label: string
}
export interface NotificationEvent {
  targetUrl: string
  isSeen: boolean
  image: string
  typeGroupHumanName: string
  isRead: boolean
  isAnnouncement: boolean
  message: string
  state: 'warning' | 'primary' | 'danger' | 'success' | 'info'
  data: {
    threadId: number
    messageId: number
    classifiedId: number
  }
  event: number
  classified: Classified
  title: string
  name: string
  messageType: string
  created: string
  id: number
  project: string
  isSent: boolean
  classifiedId: []
  action: number
  type: string
  typeGroup: string
}

export interface NotificationUnsubscribeInfo {
  email: string
  schema: object
  token: string
  topic: string
}

export enum NotificationTypeEnum {
  NEW_CLASSIFIED = 'new_classified',
  CLASSIFIED_DELETION = 'classified_deletion',
  CLASSIFIED_PARKING_OFFER = 'classified_parking_offer',
  CLASSIFIED_PRICE_REDUCTION = 'classified_price_reduction',
  NEW_USER_MESSAGE = 'new_user_message',
  NEW_ANNOUNCEMENT = 'new_announcement'
}
